import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { AuddlySignUpFormStep } from 'types/enums';

interface AuddlySignUpFormStepIndicatorProps {
  step: string;
}

export const AuddlySignUpFormStepIndicator = ({
  step,
}: AuddlySignUpFormStepIndicatorProps) => (
  <Flex
    marginX={0}
    marginTop={2}
    marginBottom={8}
    justifyContent="space-between"
  >
    <Box
      backgroundColor={
        step === AuddlySignUpFormStep.PASSWORD_CREATION ? 'B.80' : 'borderBase'
      }
      height="4px"
      borderRadius={4}
      width="50%"
      mr={1}
    />
    <Box
      backgroundColor={
        step === AuddlySignUpFormStep.LOCATION_DETAILS ? 'B.80' : 'borderBase'
      }
      height="4px"
      borderRadius={4}
      width="50%"
      ml={1}
    />
  </Flex>
);
